import React, { useState, useEffect } from "react";
import HeaderData from "../HeaderData";
import { FirstStepContent } from "./FirstStepContent";
import { BankChooser } from "../StepperComponents/BankChooser";
import { Stepper } from "../StepperComponents/Stepper";
import { ThirdStepContent } from "./ThirdStepContent";
import {
  SingleOption,
  customStyles,
} from "../utils/utils.js";
import {
  showGreyBackground,
  hideGreyBackground,
  displayLoader,
  hideLoader,
  openWindowWithPost
} from "../utils/windows";
import { getUpdateDate } from "../utils/monthNames";
import CustomModal from "../CustomModal";
import Cookies from "universal-cookie";
import { useHistory } from "react-router-dom";
import Select from "react-select";

export const AbonarEnBanco = ({ rutConcesionario, token, cabecera, pageYOffset, callServiceHandler }) => {
  const [step, setStep] = useState(1);
  const [lineasAbono, setLineasAbono] = useState([]);
  const [error, setError] = useState(false);
  const [bank, setBank] = useState();
  const [convenio, setBankConvenio] = useState();
  const [bankName, setBankName] = useState("");
  const [abonos, setAbonos] = useState([]);
  const [updateDate, setUpdateDate] = useState("");
  const [displayModal, setDisplayModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalText, setModalText] = useState("");
  const cookies = new Cookies();

  const [pagador, setPagador] = useState("");
  const [clientName, setClientName] = useState("");
  const [clientAddress, setClientAddress] = useState("");
  const history = useHistory();
  const [isArcoprime, setIsArcoprime] = useState(false);
  const [selectedEdsArcoprime, setSelectedEdsArcoprime] = useState();
  const [allEdsArcoprime, setAllEdsArcoprime] = useState([]);
  const [banksOptions, setBankOptions] = useState([]);
  const [bankOptionsMessage, setBankOptionsMessage] = useState([{
    MENSAJE: "",
    ACTIVO: "O",
  }]);
  const [displayWarningModal, setDisplayWarningModal] = useState(false);
  const warningModalTitle = "Aviso";

  const safeLineasAbono = Array.isArray(lineasAbono) ? lineasAbono : [];
  const safeAbonos = Array.isArray(abonos) ? abonos : [];
  const safeBanksOptions = Array.isArray(banksOptions) ? banksOptions : [];
  const safeAllEdsArcoprime = Array.isArray(allEdsArcoprime) ? allEdsArcoprime : [];
  const safeBankOptionsMessage = Array.isArray(bankOptionsMessage) && bankOptionsMessage.length > 0
    ? bankOptionsMessage
    : [{ MENSAJE: "", ACTIVO: "" }];

  useEffect(() => {
    console.log("[AbonarEnBanco][MOUNT/PROPS]", {
      rutConcesionario,
      tokenExiste: !!token,
      cabecera,
      cabeceraExiste: !!cabecera,
      pageYOffset,
      environment: process.env.REACT_APP_ENVIRONMENT,
    });
  }, []);

  useEffect(() => {
    console.log("[AbonarEnBanco][STATE CHANGE]", {
      step,
      error,
      bank,
      convenio,
      bankName,
      lineasAbono,
      lineasAbonoIsArray: Array.isArray(lineasAbono),
      lineasAbonoLength: Array.isArray(lineasAbono) ? lineasAbono.length : null,
      safeLineasAbonoLength: safeLineasAbono.length,
      abonos,
      abonosIsArray: Array.isArray(abonos),
      abonosLength: Array.isArray(abonos) ? abonos.length : null,
      safeAbonosLength: safeAbonos.length,
      banksOptions,
      banksOptionsIsArray: Array.isArray(banksOptions),
      banksOptionsLength: Array.isArray(banksOptions) ? banksOptions.length : null,
      safeBanksOptionsLength: safeBanksOptions.length,
      allEdsArcoprime,
      allEdsArcoprimeIsArray: Array.isArray(allEdsArcoprime),
      allEdsArcoprimeLength: Array.isArray(allEdsArcoprime) ? allEdsArcoprime.length : null,
      safeAllEdsArcoprimeLength: safeAllEdsArcoprime.length,
      bankOptionsMessage,
      bankOptionsMessageIsArray: Array.isArray(bankOptionsMessage),
      bankOptionsMessageLength: Array.isArray(bankOptionsMessage) ? bankOptionsMessage.length : null,
      safeBankOptionsMessage,
      isArcoprime,
      selectedEdsArcoprime,
      displayModal,
      displayWarningModal,
    });

    if (!Array.isArray(lineasAbono)) {
      console.warn("[AbonarEnBanco][WARN] lineasAbono no es array", lineasAbono);
    }

    if (!Array.isArray(abonos)) {
      console.warn("[AbonarEnBanco][WARN] abonos no es array", abonos);
    }

    if (!Array.isArray(banksOptions)) {
      console.warn("[AbonarEnBanco][WARN] banksOptions no es array", banksOptions);
    }

    if (!Array.isArray(allEdsArcoprime)) {
      console.warn("[AbonarEnBanco][WARN] allEdsArcoprime no es array", allEdsArcoprime);
    }

    if (!Array.isArray(bankOptionsMessage)) {
      console.warn("[AbonarEnBanco][WARN] bankOptionsMessage no es array", bankOptionsMessage);
    }
  }, [
    step,
    error,
    bank,
    convenio,
    bankName,
    lineasAbono,
    abonos,
    banksOptions,
    allEdsArcoprime,
    bankOptionsMessage,
    isArcoprime,
    selectedEdsArcoprime,
    displayModal,
    displayWarningModal,
  ]);

  useEffect(() => {
    console.log("[AbonarEnBanco][useEffect token/rutConcesionario]", {
      tokenExiste: !!token,
      rutConcesionario,
      environment: process.env.REACT_APP_ENVIRONMENT,
    });

    if (process.env.REACT_APP_ENVIRONMENT !== "dev") {
      if (token && rutConcesionario) {
        console.log("[AbonarEnBanco][INIT PROD/QA] Ejecutando servicios iniciales");

        getLineasAbono();
        getUpdateDate(setUpdateDate);
        getBancosAndMessage();

        if (rutConcesionario === "77215640-5") {
          console.log("[AbonarEnBanco][INIT PROD/QA] Es Arcoprime, ejecutando getFiliales");
          setIsArcoprime(true);
          getFiliales();
        }
      } else {
        console.warn("[AbonarEnBanco][INIT PROD/QA] No ejecuta servicios porque falta token o rutConcesionario", {
          tokenExiste: !!token,
          rutConcesionario,
        });
      }
    } else {
      if (token) {
        console.log("[AbonarEnBanco][INIT DEV] Ejecutando servicios iniciales");

        getLineasAbono();
        getUpdateDate(setUpdateDate);
        getBancosAndMessage();

        if (rutConcesionario === "77215640-5" /* || true */) {
          console.log("[AbonarEnBanco][INIT DEV] Es Arcoprime, ejecutando getFiliales");
          setIsArcoprime(true);
          getFiliales();
        }
      } else {
        console.warn("[AbonarEnBanco][INIT DEV] No ejecuta servicios porque falta token");
      }
    }
  }, [token, rutConcesionario]);

  useEffect(() => {
    console.log("[AbonarEnBanco][useEffect cabecera]", {
      cabecera,
      cabeceraEsStringVacio: cabecera === "",
      cabeceraTieneDatosCliente: !!cabecera?.DATOS_CLIENTE,
    });

    if (cabecera !== "" && cabecera?.DATOS_CLIENTE) {
      setClientName(cabecera.DATOS_CLIENTE.NOMBRE);
      setClientAddress(cabecera.DATOS_CLIENTE.DIRECCION);
      setPagador(cabecera.DATOS_CLIENTE.PAGADOR);
    } else if (cabecera !== "") {
      console.warn("[AbonarEnBanco][WARN] cabecera no viene vacía, pero no tiene DATOS_CLIENTE", cabecera);
    }
  }, [cabecera]);

  async function getLineasAbono() {
    console.log("[AbonarEnBanco][getLineasAbono][START]", {
      rutConcesionario,
    });

    displayLoader();

    const url =
      process.env.REACT_APP_BASE_API +
      "/cuenta-corriente/listar-linea-abono?rut_concesionario=" +
      rutConcesionario;

    console.log("[AbonarEnBanco][getLineasAbono][URL]", url);

    try {
      let result = await callServiceHandler(url, "GET");

      console.log("[AbonarEnBanco][getLineasAbono][RESULT]", result);
      console.log("[AbonarEnBanco][getLineasAbono][DATA]", result?.data);
      console.log("[AbonarEnBanco][getLineasAbono][LINEAS]", result?.data?.LINEAS, {
        lineasIsArray: Array.isArray(result?.data?.LINEAS),
        lineasLength: Array.isArray(result?.data?.LINEAS) ? result.data.LINEAS.length : null,
      });

      if (result !== "error") {
        if (Array.isArray(result?.data?.LINEAS)) {
          console.log("[AbonarEnBanco][getLineasAbono] Seteando LINEAS reales");
          setLineasAbono(result.data.LINEAS);

          if (!cookies.get("popup")) {
            setModalTitle("Habilitar Pop Ups");
            setModalText("Para realizar pagos, habilita los pop ups en tu navegador. Para habilitar pop ups, sigue las siguientes instrucciones:");
            setDisplayModal(true);

            showGreyBackground();
            cookies.set("popup", "yamostrado", {
              path: "/",
              expires: new Date(2040, 11, 17),
            });
          }
        } else {
          console.warn("[AbonarEnBanco][getLineasAbono] No viene LINEAS como array. Seteando []", {
            data: result?.data,
            mensaje: result?.data?.ET_MENSAJE || result?.data?.EV_MENSAJE,
            error: result?.data?.ERROR,
          });

          setLineasAbono([]);
        }
      } else {
        console.warn("[AbonarEnBanco][getLineasAbono] callServiceHandler devolvió error. Seteando []");
        setLineasAbono([]);
      }
    } catch (err) {
      console.error("[AbonarEnBanco][getLineasAbono][CATCH]", err);
      setLineasAbono([]);
    }

    hideLoader();
  }

  async function confirmAbono(bankName) {
    console.log("[AbonarEnBanco][confirmAbono][START]", {
      bankName,
      bank,
      convenio,
      isArcoprime,
      selectedEdsArcoprime,
      abonos,
      abonosIsArray: Array.isArray(abonos),
      safeAbonos,
      lineasAbono,
      lineasAbonoIsArray: Array.isArray(lineasAbono),
      safeLineasAbono,
    });

    let shortBank = "";

    if (bankName === "BANCO DE CREDITO E INVERSIONES") {
      shortBank = "BCI";
    }
    if (bankName === "BANCO SANTANDER") {
      shortBank = "SANTA";
    }
    if (bankName === "BANCO DE CHILE") {
      shortBank = "CHILE";
    }
    if (bankName === "BANCO DEL ESTADO DE CHILE") {
      shortBank = "ESTAD";
    }
    if (bankName === "SCOTIABANK") {
      shortBank = "SCOTI";
    }

    console.log("[AbonarEnBanco][confirmAbono] shortBank calculado", {
      bankName,
      shortBank,
    });

    let totald = 0;

    safeAbonos.forEach((abono) => {
      totald += parseInt(abono.monto);
    });

    const debugData = {
      abonos: safeAbonos,
      lineasAbono: safeLineasAbono,
      totalSaldo: totald,
      rutConcesionario: rutConcesionario,
      banco: bankName,
      bancoId: bank,
      clientName: clientName,
      clientAddress: clientAddress,
      tipo: "abono",
    };

    let data = {};

    if (isArcoprime) {
      if (!selectedEdsArcoprime) {
        console.warn("[AbonarEnBanco][confirmAbono] Arcoprime sin EDS seleccionada", {
          selectedEdsArcoprime,
        });
      }

      data = {
        id_eds: selectedEdsArcoprime?.value,
        abonos: safeAbonos,
        via_pago: shortBank,
        calculo: debugData
      };
    } else {
      data = {
        abonos: safeAbonos,
        rut_concesionario: rutConcesionario,
        via_pago: shortBank,
        calculo: debugData
      };
    }

    const url =
      process.env.REACT_APP_BASE_API + "/cuenta-corriente/crear-abono";

    console.log("[AbonarEnBanco][confirmAbono][POST crear-abono]", {
      url,
      data,
    });

    try {
      let result = await callServiceHandler(url, "POST", JSON.stringify(data));

      console.log("[AbonarEnBanco][confirmAbono][RESULT crear-abono]", result);

      if (result !== "error") {
        console.log("[AbonarEnBanco][confirmAbono][GRUPOPPTA]", result?.data?.GRUPOPPTA);

        if (result?.data?.GRUPOPPTA !== "") {
          let total = 0;

          safeAbonos.forEach((abono) => {
            total += parseInt(abono.monto);
          });

          let url2 =
            process.env.REACT_APP_BASE_API + "/cuenta-corriente/obtener-url-banco?"
            + "rut_concesionario=" + rutConcesionario
            + "&monto=" + total
            + "&banco=" + bank
            + "&grupo_ppta=" + result.data.GRUPOPPTA;

          console.log("[AbonarEnBanco][confirmAbono][GET obtener-url-banco]", {
            url2,
            total,
          });

          let result2 = await callServiceHandler(url2, "GET");

          console.log("[AbonarEnBanco][confirmAbono][RESULT obtener-url-banco]", result2);

          if (result2 !== "error") {
            if (result2?.data?.url_method === "GET") {
              console.log("[AbonarEnBanco][confirmAbono] Abriendo banco por GET", result2?.data?.url);
              window.open(result2.data.url + "&origen=1");
            } else {
              console.log("[AbonarEnBanco][confirmAbono] Abriendo banco por POST", {
                url: result2?.data?.url,
                xml: result2?.data?.xml,
                parameter: result2?.data?.parameter,
              });

              const data = {};
              data["xml"] = result2?.data?.parameter;
              openWindowWithPost(result2.data.url, result2.data.xml, rutConcesionario, pagador, result.data.GRUPOPPTA, bank);
            }
          } else {
            console.warn("[AbonarEnBanco][confirmAbono] obtener-url-banco devolvió error");
          }

          saveData(result.data.GRUPOPPTA, total);

          setModalTitle("Redireccionando");
          setModalText("Ha sido redirigido al medio de pago seleccionado. Si ya termino de pagar, por favor revise en Historial de Pagos.");
          setDisplayModal(true);

          hideLoader();
          showGreyBackground();
          setError(false);
        } else {
          console.warn("[AbonarEnBanco][confirmAbono] GRUPOPPTA vacío o inválido", result?.data);
        }
      } else {
        console.warn("[AbonarEnBanco][confirmAbono] crear-abono devolvió error. Pasando a step 3 error.");
        setError(true);
        setStep(3);
      }
    } catch (err) {
      console.error("[AbonarEnBanco][confirmAbono][CATCH]", err);
      setError(true);
      setStep(3);
    }
  }

  function end() {
    console.log("[AbonarEnBanco][end] Reiniciando flujo");

    setStep(1);
    setAbonos([]);
  }

  function closeModal() {
    console.log("[AbonarEnBanco][closeModal]", {
      modalTitle,
    });

    setDisplayModal(false);
    hideLoader();
    hideGreyBackground();

    if (modalTitle === "Redireccionando") {
      history.go(0);
    }
  }

  function closeWarningModal() {
    console.log("[AbonarEnBanco][closeWarningModal]", {
      modalTitle,
    });

    setDisplayWarningModal(false);
    hideLoader();
    hideGreyBackground();

    if (modalTitle === "Redireccionando") {
      history.go(0);
    }
  }

  async function changeEdsArcoprime(e) {
    console.log("[AbonarEnBanco][changeEdsArcoprime]", e);
    setSelectedEdsArcoprime(e);
  }

  const saveData = (propuesta, totalS) => {
    const data = {
      propuesta: propuesta,
      abonos: safeAbonos,
      lineasAbono: safeLineasAbono,
      totalSaldo: totalS,
      rutConcesionario: rutConcesionario,
      banco: bankName,
      bancoId: bank,
      clientName: clientName,
      clientAddress: clientAddress,
      tipo: "abono",
    };

    console.log("[AbonarEnBanco][saveData]", {
      propuesta,
      data,
    });

    window.localStorage.setItem(propuesta, JSON.stringify(data));
  };

  const goBack = () => {
    console.log("[AbonarEnBanco][goBack] Volviendo a step 1");
    setStep(1);
  };

  function buildEdsOption(eds) {
    let ide = eds.ID_EDS;
  
    if (typeof ide !== "string") {
      console.warn("[AbonarEnBanco][getFiliales] ID_EDS no es string", eds);
      ide = String(ide || "");
    }
  
    while (ide.charAt(0) === "0") {
      ide = ide.substring(1);
    }
  
    return {
      value: eds.ID_EDS,
      label: ide + " - " + eds.DIRECCION,
    };
  }

  async function getFiliales() {
    console.log("[AbonarEnBanco][getFiliales][START]");
  
    displayLoader();
  
    const url =
      process.env.REACT_APP_BASE_API +
      "/cuenta-corriente/listar-filiales?rut_concesionario=77215640-5";
  
    console.log("[AbonarEnBanco][getFiliales][URL]", url);
  
    try {
      let result = await callServiceHandler(url, "GET");
  
      console.log("[AbonarEnBanco][getFiliales][RESULT]", result);
      console.log("[AbonarEnBanco][getFiliales][FILIALES]", result?.data?.FILIALES, {
        filialesIsArray: Array.isArray(result?.data?.FILIALES),
        filialesLength: Array.isArray(result?.data?.FILIALES) ? result.data.FILIALES.length : null,
      });
  
      if (result === "error") {
        console.warn("[AbonarEnBanco][getFiliales] callServiceHandler devolvió error. Seteando []");
        setAllEdsArcoprime([]);
        return;
      }
  
      const filiales = result?.data?.FILIALES;
  
      if (!Array.isArray(filiales)) {
        console.warn("[AbonarEnBanco][getFiliales] FILIALES no viene como array. Seteando []", result?.data);
        setAllEdsArcoprime([]);
        return;
      }
  
      setAllEdsArcoprime(filiales.map(buildEdsOption));
    } catch (err) {
      console.error("[AbonarEnBanco][getFiliales][CATCH]", err);
      setAllEdsArcoprime([]);
    } finally {
      hideLoader();
    }
  }

  async function getBancosAndMessage() {
    console.log("[AbonarEnBanco][getBancosAndMessage][START]", {
      rutConcesionario,
    });

    displayLoader();

    let url =
      process.env.REACT_APP_BASE_API +
      "/cuenta-corriente/obtener-bancos-mensaje?rut_concesionario=" +
      rutConcesionario;

    console.log("[AbonarEnBanco][getBancosAndMessage][URL]", url);

    try {
      let result = await callServiceHandler(url, "GET");

      console.log("[AbonarEnBanco][getBancosAndMessage][RESULT]", result);
      console.log("[AbonarEnBanco][getBancosAndMessage][DATA]", result?.data);
      console.log("[AbonarEnBanco][getBancosAndMessage][BANCOS]", result?.data?.BANCOS, {
        bancosIsArray: Array.isArray(result?.data?.BANCOS),
        bancosLength: Array.isArray(result?.data?.BANCOS) ? result.data.BANCOS.length : null,
      });
      console.log("[AbonarEnBanco][getBancosAndMessage][MENSAJES]", result?.data?.MENSAJES, {
        mensajesIsArray: Array.isArray(result?.data?.MENSAJES),
        mensajesLength: Array.isArray(result?.data?.MENSAJES) ? result.data.MENSAJES.length : null,
      });

      if (result !== "error") {
        const data = result.data;
        const banks = [];
        const message = [{
          MENSAJE: data?.MENSAJES?.[0]?.MENSAJE || "",
          ACTIVO: data?.MENSAJES?.[0]?.ACTIVO || "",
        }];

        if (Array.isArray(data?.BANCOS)) {
          data.BANCOS.forEach(function (bnk) {
            const newBank = {
              CONVENIO: bnk.CONVENIO,
              CLAVE_BANCO: bnk.CLAVE_BANCO,
            };

            banks.push(newBank);
          });
        } else {
          console.warn("[AbonarEnBanco][getBancosAndMessage] BANCOS no viene como array. Seteando []", data);
        }

        console.log("[AbonarEnBanco][getBancosAndMessage] Seteando bancos y mensajes", {
          banks,
          message,
        });

        setBankOptions(banks);
        setBankOptionsMessage(message);

        if (message[0].ACTIVO === "X") {
          console.log("[AbonarEnBanco][getBancosAndMessage] Mensaje activo, mostrando warning modal");
          setDisplayWarningModal(true);
        }
      } else {
        console.warn("[AbonarEnBanco][getBancosAndMessage] callServiceHandler devolvió error. Seteando []");
        setBankOptions([]);
        setBankOptionsMessage([{
          MENSAJE: "",
          ACTIVO: "",
        }]);
      }
    } catch (err) {
      console.error("[AbonarEnBanco][getBancosAndMessage][CATCH]", err);
      setBankOptions([]);
      setBankOptionsMessage([{
        MENSAJE: "",
        ACTIVO: "",
      }]);
    }

    hideLoader();
  }

  console.log("[AbonarEnBanco][RENDER BEFORE RETURN]", {
    step,
    error,
    safeLineasAbonoLength: safeLineasAbono.length,
    safeAbonosLength: safeAbonos.length,
    safeBanksOptionsLength: safeBanksOptions.length,
    safeAllEdsArcoprimeLength: safeAllEdsArcoprime.length,
    safeBankOptionsMessage,
  });

  return (
    <div className="abonar-en-banco">
      <div className="title-container">
        <div className="title">
          <div className="view-title">Cuenta corriente</div>
          <div className="view-title-separator">|</div>
          <div className="view-subtitle">Realizar abonos</div>
        </div>
        {step === 2 ? (
          <>
            <div className="volver-arrow" onClick={() => goBack()}>
              <img></img>
              <p className="volver-text">Volver</p>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>

      <hr className="title-separator-line" />

      <HeaderData
        rutConcesionario={rutConcesionario}
        token={token}
        actualizacion={updateDate}
        cabecera={cabecera}
        callServiceHandler={callServiceHandler}
      />

      <hr />

      {isArcoprime && (
        <div className="filters-container arcoprime">
          <div className="filter">
            <div className="filter-title">ESTACIÓN DE SERVICIO</div>
            <div className="filter-input">
              <Select
                className="eds-select"
                value={selectedEdsArcoprime}
                onChange={(e) => changeEdsArcoprime(e)}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                options={safeAllEdsArcoprime}
                components={{ SingleOption, IndicatorSeparator: () => null }}
                isClearable={false}
                autosize={false}
                placeholder="Seleccionar"
                styles={customStyles}
                isDisabled={step !== 1}
              />
            </div>
          </div>
        </div>
      )}

      <div
        className={`abonar-en-banco__content test-abono ${isArcoprime ? "arcoprime" : ""}`}
      >
        <Stepper
          step={step}
          error={error}
          totalSteps={3}
          title="Abono en Cuenta"
          step1Title="Confirmar"
          step2Title="Abonar"
          step3Title="Finalizar"
        />

        <CustomModal
          displayModal={displayWarningModal}
          closeModal={closeWarningModal}
          acceptFunc={closeWarningModal}
          modalTitle={warningModalTitle}
          modalText={safeBankOptionsMessage[0].MENSAJE}
          modalIcon="importante"
        />

        {step === 1 && (
          <>
            {console.log("[AbonarEnBanco][RENDER FirstStepContent]", {
              lineasAbonoOriginal: lineasAbono,
              safeLineasAbono,
              safeLineasAbonoLength: safeLineasAbono.length,
            })}
            <FirstStepContent
              setStep={setStep}
              setAbonos={setAbonos}
              rutConcesionario={rutConcesionario}
              lineasAbono={safeLineasAbono}
              selectedEdsArcoprime={selectedEdsArcoprime}
              isArcoprime={isArcoprime}
              pageYOffset={pageYOffset}
            />
          </>
        )}

        {step === 2 && (
          <>
            {console.log("[AbonarEnBanco][RENDER BankChooser]", {
              bank,
              convenio,
              bankName,
              banksOptionsOriginal: banksOptions,
              safeBanksOptions,
              safeBanksOptionsLength: safeBanksOptions.length,
            })}
            <BankChooser
              setStep={setStep}
              confirmAbono={confirmAbono}
              bank={bank}
              convenio={convenio}
              setBank={setBank}
              setBankName={setBankName}
              bankName={bankName}
              setBankConvenio={setBankConvenio}
              closeStepper={setStep}
              closeWithParameter={true}
              pageYOffset={pageYOffset}
              banksList={safeBanksOptions}
            />
          </>
        )}

        {step === 3 && (
          <>
            {console.log("[AbonarEnBanco][RENDER ThirdStepContent]", {
              error,
              bank,
              abonosOriginal: abonos,
              safeAbonos,
              safeAbonosLength: safeAbonos.length,
              lineasAbonoOriginal: lineasAbono,
              safeLineasAbono,
              safeLineasAbonoLength: safeLineasAbono.length,
            })}
            <ThirdStepContent
              error={error}
              end={end}
              abonos={safeAbonos}
              bank={bank}
              lineasAbono={safeLineasAbono}
            />
          </>
        )}

        <CustomModal
          displayModal={displayModal}
          closeModal={closeModal}
          acceptFunc={closeModal}
          modalTitle={modalTitle}
          modalText={modalText}
          modalIcon="success"
        />

      </div>
    </div>
  );
};